import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';

import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter basename='/'>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);

// Pour mesurer les performances de l'application
reportWebVitals();
